import { PropsWithChildren } from 'react';

export const NoopComponent = ({ children }: PropsWithChildren) => (
    <>{children}</>
);
